<template>
  <div class="ma-4">
    <products
      exclude-event-templates
      exclude-requests
      exclude-required
      display-mode="cashDesk"
      exclude-inactive
      @click:product="bookProduct"
    />
  </div>
</template>

<script>
import Products from '../../products/Products'

export default {
  name: 'CashDeskView',
  components: { Products },

  methods: {
    bookProduct(productInstance) {
      this.$router.push({
        name: 'createBookingOverview',
        params: {
          displayMode: 'cashDesk',
          product: productInstance,
        },
      })
    },
  },
}
</script>
